import Api from '../api/reconApi.js';
import * as getInfo from './apiGetInfo';
import * as lookups from './lookups';
import * as AllMutates from './AllMutates';

export function updateCustomForm(id, data, errorType) {
    return dispatch => Api.patchData(`custom_forms/${id}`, data).then((resp) => {
        dispatch(getInfo.getCustomForms());
        return 'success';
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateCustomFormPage(id, key, data, errorType) {
    return dispatch => Api.patchData(`custom_forms/${id}`, data).then((resp) => {
        dispatch(getInfo.getCustomForms());
        return 'success';
    }).catch(ex => Api.handleApiError(ex, errorType));
}


export function createCustomForm(data, errorType) {
    return dispatch => Api.postData('custom_forms/', data).then((resp) => {
       return 'success';
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteCustomForm(id, errorType) {
    return dispatch => Api.delete(`custom_forms/${id}`).then(() => dispatch(getInfo.getCustomForms())).catch(ex => Api.handleApiError(ex, errorType));
}


export function deleteCustomFormProperty(id, vid, errorType = 'deleteCustomFormProperty Error') {
	return (dispatch, getState) => Api.delete(`custom_form_properties/${id}`).then((resp) => {
		dispatch(getInfo.getCustomForms());
        return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function createCustomFormPropertyRaw(data, errorType) {
	return (dispatch, getState) => Api.postData('custom_form_properties/', data).then((resp) => {
        return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}


export function createCustomFormProperty(data, errorType) {
	return (dispatch, getState) => Api.postData('custom_form_properties/', data).then((resp) => {
		dispatch(getInfo.getCustomForms());
        return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}
export function updateCustomFormProperty(id, data, errorType) {
    return dispatch => Api.patchData(`custom_form_properties/${id}`, data).then((resp) => {
        dispatch(getInfo.getCustomForms());
        return 'success';
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateCustomFormOrder(items, errorType) {
	return (dispatch) => {
		items.map((item, i) => {
			const data = {
				id: item,
				order: i,
			};

			return Api.patchData(`custom_form_properties/${item}`, data).then(() => {
			}).catch(ex => Api.handleApiError(ex, errorType));
		});

		dispatch(getInfo.getCustomForms());
	};
}